import type { FC, ReactNode } from 'react'

import { ArrowRight, CalendarClock } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button-link'
import { LogoMark } from '@/components/generals/logo'
import { MAILTO_GESPREK } from '@/constants/leesritme'

export const ClosingCta: FC = (): ReactNode => {
    return (
        <section id='start' className='px-5 pb-20 sm:px-8 sm:pb-28'>
            <div className='relative isolate mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-ink px-6 py-16 text-center text-paper sm:px-12 sm:py-24'>
                <div aria-hidden='true' className='pointer-events-none absolute inset-0 -z-10'>
                    <div className='absolute -bottom-40 left-1/2 size-[42rem] -translate-x-1/2 rounded-full bg-[radial-gradient(circle_at_center,rgb(234_111_75/0.45),rgb(246_207_93/0.12)_45%,transparent_70%)]' />
                </div>

                <LogoMark className='mx-auto size-14 text-paper' />

                <h2 className='mx-auto mt-6 max-w-3xl font-heading font-soft text-4xl leading-[1.05] font-semibold tracking-[-0.015em] text-balance sm:text-6xl'>
                    Maak van lezen een <span className='font-medium text-sun italic'>dagelijks ritme.</span>
                </h2>

                <p className='mx-auto mt-6 max-w-xl text-lg leading-relaxed text-[#c3cad8]'>
                    Tien minuten per dag, in de klas en thuis. Probeer het gratis met je klas, zonder verplichting.
                </p>

                <div className='mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row'>
                    <ButtonLink href='#aanmelden' variant='light' size='lg'>
                        Start gratis met je klas
                        <ArrowRight className='size-4' aria-hidden='true' />
                    </ButtonLink>

                    <ButtonLink href={MAILTO_GESPREK} variant='outline-light' size='lg'>
                        <CalendarClock className='size-4' aria-hidden='true' />
                        Plan 20 minuten met Roman
                    </ButtonLink>
                </div>
            </div>
        </section>
    )
}
